<template>
  <v-flex
    xs12
    md10
    d-flex
  >
    <search-filter
      v-model="search"
      :vflex-props="{ xs6: true}"
      @search="submit()"
    />
    <status-filter
      v-model="situation"
      :vflex-props="{ xs4: true}"
      :status="status"
      class="ml-3"
      @input="submit()"
    />
    <input-text
      v-model="clientIdSgv"
      label="Cliente ID Sgv"
      class="ml-3"
      clearable
      @blur="submit()"
    />
  </v-flex>
</template>

<script>
import SearchFilter from 'Support/components/crud/SearchFilter.vue';
import StatusFilter from 'Support/components/crud/StatusFilter.vue';
import RouterMixin from 'Support/mixins/router-mixin';
import InputText from 'Support/components/inputs/InputText.vue';

export default {
  name: 'CustomersFilter',
  components: {
    SearchFilter,
    StatusFilter,
    InputText,
  },
  mixins: [RouterMixin],
  data: vm => ({
    search: '',
    situation: {
      value: '',
    },
    clientIdSgv: '',
    status: [
      {
        value: vm.$t('app.customers.situations.enum.active'),
        text: vm.$t('app.customers.situations.active'),
      },
      {
        value: vm.$t('app.customers.situations.enum.inactive'),
        text: vm.$t('app.customers.situations.inactive'),
      },
      {
        value: vm.$t('app.customers.situations.enum.blocked'),
        text: vm.$t('app.customers.situations.blocked'),
      },
    ],
  }),
  created() {
    const { query } = this.$route;
    this.search = query.search || '';
    this.situation = this.status.find(item => item.value === query.status) || {};
  },
  methods: {
    submit() {
      let status = null;
      if (this.situation && this.situation.value) {
        status = this.situation.value;
      }
      this.updateQueryParams({
        search: this.search || undefined,
        status: status || undefined,
        clienteIdSgv: this.clientIdSgv || undefined,
      });
    },
  },
};
</script>
